import styled from 'styled-components';

const NavMenuItem = styled.button`
  align-items: center;
  appearance: none;
  background: transparent;
  border: none;
  box-sizing: border-box;
  border-radius: 1rem;
  color: ${Styles.color.white};
  display: inline-flex;
  font-family: ${Styles.fontFamily.base};
  font-size: 1.125rem;
  height: 100%;
  justify-content: center;
  margin-left: 1.35rem;
  padding: 0;
  position: relative;
  cursor: pointer;
`;

export default NavMenuItem;
